<template>
    <div class="c-overview-box flex-grid flex-grid--reduced-bottom-margin-slight u-position-relative">
        <div class="box u-d-flex flex-grid--wrap u-flex-wrap">
            <slot></slot>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'overview-box',
    }

</script>

<style lang="scss">
	@import '../assets/sass/base/colours.scss';
	@import '../assets/sass/view/component/overview-box.scss';
</style>



// WEBPACK FOOTER //
// OverviewBox.vue?32a7f6bd